import React from 'react'
import './Experience.css'
import { themeContext } from '../../Context'
import { useContext } from 'react'
const Experience = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="experience" id="Experience">
    <div className="achievements">
        <div className="circle" >400+</div>
        <span>Problems</span>
        <span>Solved</span>
    </div>
    <div className="achievements">
        <div className="circle">6+</div>
        <span>Completed</span>
        <span>Projects</span>
    </div>
    <div className="achievements">
        <div className="circle">5+</div>
        <span>Courses</span>
        <span>Certificates</span>
    </div>
    </div>
  )
}

export default Experience